import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../StaffMaster.css';
import InputField from './InputField'; // Import the component

const StaffMaster = () => {
    const [staffList, setStaffList] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        father: '',
        address: '',
        mobile: '',
        username: '',
        password: '',
        role: 'Caller', // Default role
        active: false,
        id: null,
    });
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [formError, setFormError] = useState('');

    const token = localStorage.getItem('authToken'); // Retrieve token for authentication

    useEffect(() => {
        fetchStaffList();
    }, []);

    const fetchStaffList = async () => {
        try {
            const response = await axios.get('https://astrovidhya.in/api/staff', {
                headers: { Authorization: `Bearer ${token}` },
            });
            setStaffList(response.data);
        } catch (error) {
            console.error('Error fetching staff list:', error);
            setError('Failed to fetch staff list. Please try again.');
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form data
        if (!formData.name || !formData.username || !formData.password || !formData.mobile) {
            setFormError('All fields are required, including mobile.');
            return;
        }

        const method = formData.id ? 'PUT' : 'POST';
        const url = formData.id
            ? `https://astrovidhya.in/api/staff/${formData.id}`
            : 'https://astrovidhya.in/api/staff';

        try {
            const response = await axios({
                method,
                url,
                data: formData,
                headers: { Authorization: `Bearer ${token}` },
            });

            if (method === 'POST') {
                setStaffList([...staffList, response.data]);
            } else {
                setStaffList(staffList.map((staff) =>
                    staff._id === response.data._id ? response.data : staff
                ));
            }

            setSuccessMessage('Staff member added/updated successfully!');
            resetForm();
        } catch (error) {
            console.error('Error submitting form:', error);
            setFormError('Failed to submit data. Please try again.');
        }
    };

    const handleRowClick = (staff) => {
        setFormData({
            ...staff,
            id: staff._id,
        });
    };

    const resetForm = () => {
        setFormData({
            name: '',
            father: '',
            address: '',
            mobile: '',
            username: '',
            password: '',
            role: 'Caller', // Reset role to default
            active: false,
            id: null,
        });
        setFormError('');
        setSuccessMessage('');
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this staff member?')) {
            try {
                await axios.delete(`https://astrovidhya.in/api/staff/${id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setStaffList(staffList.filter((staff) => staff._id !== id));
                setSuccessMessage('Staff member deleted successfully!');
            } catch (error) {
                console.error('Error deleting staff member:', error);
                setError('Failed to delete staff member. Please try again.');
            }
        }
    };

    return (
        <div className="staff-master-container">
            <div className="form-panel">
            <h3 className="font-bold">Add Staff Member</h3> 
                <form onSubmit={handleSubmit}>
                    <label>Name</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange}  maxLength={40} required />

                    <label>Father</label>
                    <input type="text" name="father" value={formData.father} onChange={handleChange} maxLength={40} required />

                    <label>Address</label>
                    <input name="address" value={formData.address} onChange={handleChange} maxLength={40} required />

                    <label>Mobile</label>
                    <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} maxLength={10} required />

                    <label>Login (Username)</label>
                    <input type="text" name="username" value={formData.username} onChange={handleChange} maxLength={40} required />

                    <label>Password</label>
                    <input type="password" name="password" value={formData.password} onChange={handleChange} maxLength={40} required />

                    <label>Role</label>
<div className="radio-buttons">
    <label>
        <input 
            type="radio" 
            name="role" 
            value="Admin" 
            checked={formData.role === 'Admin'} 
            onChange={handleChange} 
        /> Admin
    </label>
    <label>
        <input 
            type="radio" 
            name="role" 
            value="Operator" 
            checked={formData.role === 'Operator'} 
            onChange={handleChange} 
        /> Operator
    </label>
    <label>
        <input 
            type="radio" 
            name="role" 
            value="Caller" 
            checked={formData.role === 'Caller'} 
            onChange={handleChange} 
        /> Caller
    </label>
</div>

<div className="flex items-center space-x-2">
  <input
    id="active"
    type="checkbox"
    name="active"
    checked={formData.active}
    onChange={handleChange}
    className="h-5 w-5 text-[#03C9D7] focus:ring-[#03C9D7] border-gray-300 rounded"
  />
  <label htmlFor="active" className="text-gray-700 font-bold pb-5 pl-2">
    Active
  </label>
</div>






                    {formError && <p className="error-message">{formError}</p>}
                    {successMessage && <p className="success-message">{successMessage}</p>}

                    <div className="flex space-x-4 mt-4">
  <button
    type="submit"
    className="bg-[#03C9D7] hover:bg-[#02A5B3] text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300 w-1/2"
  >
    Submit
  </button>
  <button
    type="button"
    onClick={resetForm}
    className="bg-gray-500 hover:bg-gray-700 text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300 w-1/2"
  >
    Reset
  </button>
</div>
                </form>
            </div>

            <div className="list-panel">
           <h3 className="font-bold">Staff List</h3><br></br> 
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Father</th>
                            <th>Address</th>
                            <th>Mobile</th>
                            <th>Login</th>
                            <th>Password</th>
                            <th>Active</th>
                            <th>Role</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {staffList.map((staff) => (
                            <tr key={staff._id} onClick={() => handleRowClick(staff)}>
                                <td>{staff.name}</td>
                                <td>{staff.father}</td>
                                <td>{staff.address}</td>
                                <td>{staff.mobile}</td>
                                <td>{staff.username}</td>
                                <td>{staff.password}</td>
                                <td><input type="checkbox" checked={staff.active} readOnly /></td>
                                <td>{staff.role}</td>
                                <td>
  <button
    onClick={() => handleDelete(staff._id)}
    className="bg-red-500 hover:bg-red-700 text-white font-semibold py-1 px-4 rounded shadow-md transition duration-300"
  >
    Delete
  </button>
</td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StaffMaster;
